export interface OnboardingItem {
    id: string
    title: string
    description: string
    completed: boolean
    icon: string
    route?: string
    action?: () => void
    category: OnboardingCategory
    order: number
}

export enum OnboardingCategory {
    GettingStarted = 'Getting Started',
    Setup = 'Setup',
    Configuration = 'Configuration',
    Advanced = 'Advanced',
}

export interface OnboardingProgress {
    totalItems: number
    completedItems: number
    percentageComplete: number
    lastUpdated: Date
}
